import api from './config'

export function getFeature() {
    return api.get(`/features/`);
}

